import { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '@reducers/index';
import { Countries2DigitCode, country_LangCode } from '@models/commonModel';
import { gameProviderTypes } from '@configs/layout';
import ReactFlagsSelect from 'react-flags-select';
import { setLocaleValue, getLocaleValueForFlag } from '@utils/common/language';
import { useSearchParams } from 'react-router-dom';
import {
  fetchTabGridData,
  fetchAppleAutoFillData,
  fetchGooglePlaySuggestionData,
  fetchSimilarKeywordData,
  fetchSearchAdsRecommendedData,
  fetchRelatedKeywordData,
  fetchTrendingKeywordData,
} from '@reducers/keyword/thunk/suggestionThunk';
import { setInitialTabDataFrame } from '@reducers/keyword/keywordSuggestionSlice';

const AppInfoBox = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { keywordGroupList } = useSelector(({ keyword }: RootState) => keyword);
  const { myAppObj } = useSelector(({ LAYOUT }: RootState) => LAYOUT);
  const { keyword } = useSelector(({ keywordSuggestion }: RootState) => keywordSuggestion);

  const [searchParams] = useSearchParams();

  const [searchText, setSearchText] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(getLocaleValueForFlag());
  const countriesArr = Countries2DigitCode.map((item) => item.code);

  // keyword Tracking 에서 쿼리스트링으로 넘어올때 searchText 넣어주기
  useEffect(() => {
    if (!!searchParams.get('keyword')) {
      setSearchText(searchParams.get('keyword'));
    }
  }, [searchParams]);

  // registered 에서 keyword 클릭시 searchText 넣어주기
  useEffect(() => {
    if (!!keyword) {
      setSearchText(keyword);
    }
  }, [keyword]);

  const onChangeSearchText = useCallback((event) => {
    const { value } = event.target;
    setSearchText(value);
  }, []);

  const onSelectCountry = useCallback((code) => {
    setSelectedCountry(code);
  }, []);

  const onClickProcessing = useCallback(() => {
    if (myAppObj) {
      // dispatch(
      //   fetchTabGridData({
      //     keyword: searchText,
      //     country: selectedCountry,
      //   })
      // );
      // // set tab initial
      dispatch(setInitialTabDataFrame({}));
      const langIndex = country_LangCode.findIndex((item) => item.code === selectedCountry);
      const lang = langIndex > -1 ? country_LangCode[langIndex].langCode : 'en';
      // // request tab keyword data
      // appleautofill
      dispatch(
        fetchAppleAutoFillData({
          provider_type: myAppObj?.provider_type,
          keywords: [`${searchText}`],
          country: selectedCountry.toLowerCase(),
          lang: lang,
        })
      );
      // googleplaystoresuggest
      dispatch(
        fetchGooglePlaySuggestionData({
          provider_type: myAppObj?.provider_type,
          keywords: [`${searchText}`],
          country: selectedCountry.toLowerCase(),
          lang: lang,
        })
      );
      // similarkeywordTab
      dispatch(
        fetchSimilarKeywordData({
          provider_type: myAppObj?.provider_type,
          appId: myAppObj?.appId,
          country: selectedCountry.toLowerCase(),
          lang: lang,
        })
      );
      // TODO: 아래의 keyword 요청 탭은
      // searchAdsRecommendData
      const searchAdsKeyword = setTimeout(() => dispatch(fetchSearchAdsRecommendedData()), 3000);
      // dispatch(fetchSearchAdsRecommendedData());
      // registeredData,
      const registeredKeyword = setTimeout(() => dispatch(fetchRelatedKeywordData()), 3000);
      // trendingData
      const trendingKeyword = setTimeout(() => dispatch(fetchTrendingKeywordData()), 3000);

      // clearTimeout
      [searchAdsKeyword, registeredKeyword, trendingKeyword].forEach((item) => {
        () => clearTimeout(item);
      });
    }
  }, [
    searchText,
    selectedCountry,
    dispatch,
    fetchTabGridData,
    setInitialTabDataFrame,
    fetchAppleAutoFillData,
    fetchGooglePlaySuggestionData,
    myAppObj,
    country_LangCode,
    fetchSimilarKeywordData,
    fetchSearchAdsRecommendedData,
    fetchRelatedKeywordData,
    fetchTrendingKeywordData,
  ]);

  return (
    <div className="myapp-info">
      <div className="search-app">
        <div className="search-box type-1">
          <label>
            <input
              type="text"
              className="search-ipt"
              placeholder="Search for any keyword"
              value={searchText}
              onChange={onChangeSearchText}
            />
          </label>
        </div>
      </div>
      {myAppObj?.provider_type === gameProviderTypes.AppleAppStore ? (
        <span className="btn-ico-single app-s">
          <span className="blind">ios</span>
        </span>
      ) : (
        <p className="btn-ico-single android-s">
          <span className="blind">Google Store</span>
        </p>
      )}

      <div className="select-api">
        <ReactFlagsSelect
          selected={selectedCountry}
          onSelect={onSelectCountry}
          countries={countriesArr}
          searchable={true}
        />
      </div>
      {myAppObj !== null ? (
        <div className="myapp">
          <div className="myapp-img">
            <img src={myAppObj.icon} alt="" />
          </div>
          <div className="myapp-txt">
            <h2 className="myapp-tit">{myAppObj.title}</h2>
            <p className="myapp-dsc">
              {myAppObj?.genres[0]?.genreName}
              {/* {myAppInfo?.type === gameProviderTypes.GooglePlayStore
              ? myAppInfo.genre
              : myAppInfo.genres.map(item => `${item} `)} */}
            </p>
          </div>
        </div>
      ) : (
        <div className="myapp">
          <div className="myapp-img">{/* <Skeleton count={1} style={{width: '45px', height: '45px'}} /> */}</div>
          <div className="myapp-txt">
            <h2 className="myapp-tit">{/* <Skeleton count={1} style={{width: '100px'}} /> */}</h2>
            <p className="myapp-dsc">{/* <Skeleton count={1} style={{width: '100px'}} /> */}</p>
          </div>
        </div>
      )}

      <div className="icon-myapp">
        <div className="icon-myapp-svg">
          {/* 국가깃발 부분 */}
          <img alt="" src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${selectedCountry}.svg`} />
        </div>
        <span className="icon-myapp-txt">{Countries2DigitCode.find((item) => item.code === selectedCountry).name}</span>
      </div>
      <button
        type="button"
        className="btn pri"
        disabled={searchText.trim().length < 2 ? true : false}
        onClick={onClickProcessing}
      >
        Processing
      </button>
    </div>
  );
};

export default AppInfoBox;
